module.exports = __webpack_public_path__ + "img/add-green.28457116.svg";